import React, { useState } from 'react'

import { useNavigate, } from "react-router-dom";

// redux
import { useDispatch, useSelector } from 'react-redux';

import { setItemsOffset } from 'redux/actions/inventoryActions';

// language
import { injectIntl, IntlShape } from 'react-intl';

// components
import QueryTableDevices from 'components-lib/QueryTable/QueryTableDevices';
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import EditTimeDoorWarning from "components-lib/EditTimeDoorWarning";

// Material UI
import { Grid } from '@mui/material';

// icons
import { 
  containerIcon,
  kayakIcon,
  paddleIcon,
  vestIcon,
  helmetIcon,
  bagIcon,
} from 'assets/icons';

// types
import { ColumnWidths } from 'types/types';
import { ContainersData } from 'types/typesRedux';

type Props = {
  intl: IntlShape;
  warningTime: number
}

const ContainersTable = ( {intl, warningTime}: Props ) => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  
  // data from redux
  const data = useSelector( (state: ContainersData ) => state.containers )

  const [isOpenModal, setIsOpenModal] = useState(false);

  // If click on detail button set offset 0 and go to page detail container
  const handleDetailItem = ( id: number ) => {
    dispatch(setItemsOffset( 0 ));
    navigate( (`/admin/containers/container-detail/${id}`), { state: {
      id: id,
      }} 
    );
  }

  const handleModalWindow = ( bool: boolean ) => {
    setIsOpenModal(bool);
  }

  return (
    <Grid >
      <Grid 
        sx={{
          maxWidth: "92rem", marginTop: "1rem",
        }}
      >
        <MDBox
          sx={{
            display: "flex", justifyContent: "flex-end",
            width: "100%", pb: "2.5rem", paddingRight: "1rem",         
          }} 
        >
          <MDButton
            variant="contained"
            color="success"
            onClick={() => { handleModalWindow(true) }}
          >
            {intl.formatMessage({id:'button.changeWarningTime'})}
          </MDButton>
        </MDBox>
        <QueryTableDevices
          title= {intl.formatMessage( {id: 'tableContainers.title'} )}
          tableData={ data.containers }
          pagePagination={false}
          totalCount={ data.totalCount }
          marginTop='0rem'
          columns= {[
            // { Header: intl.formatMessage( {id: 'tableUsers.id'} ), 
            // accessor: "id", 
            // width: "auto",
            // minWidth: "3%",
            // input: 'title',
            // },
            { Header: intl.formatMessage( {id: 'tableContainers.name'} ), 
              accessor: "name", 
              width: "auto",
              minWidth: "10%",
              input: 'title',
            },
            { Header: intl.formatMessage( {id: 'tableContainers.status'} ), 
              accessor: "isEnabled", 
              width: "auto",
              minWidth: "10%",
              input: 'title',
            },
            { Header: intl.formatMessage( {id: 'tableContainers.doors'} ), 
              accessor: "Doors", 
              width: "auto",
              minWidth: "10%",
              input: 'title',
            },
            { Header: intl.formatMessage( {id: 'tableContainers.boatsCount'} ), 
              accessor: "boatsCount", 
              width: "auto",
              minWidth: "8%",
              input: 'title',
              titleIcon:kayakIcon,
            },
            { Header: intl.formatMessage( {id: 'tableContainers.paddleCount'} ), 
              accessor: "paddleCount", 
              width: "auto",
              minWidth: "8%",
              input: 'title',
              titleIcon:paddleIcon,
            },
            { Header: intl.formatMessage( {id: 'tableContainers.vestCount'} ), 
              accessor: "vestCount", 
              width: "auto",
              minWidth: "8%",
              input: 'title',
              titleIcon:vestIcon,
            },
            { Header: intl.formatMessage( {id: 'tableContainers.helmetCount'} ), 
              accessor: "helmetCount", 
              width: "auto",
              minWidth: "8%",
              input: 'title',
              titleIcon:helmetIcon,
            },
            { Header: intl.formatMessage( {id: 'tableContainers.bagCount'} ), 
              accessor: "bagCount", 
              width: "auto",
              minWidth: "8%",
              input: 'title',
              titleIcon:bagIcon,
            },
            { Header: intl.formatMessage( {id: 'tableContainers.equipmentCount'} ), 
              accessor: "equipmentCount", 
              width: "auto",
              minWidth: "8%",
              input: 'title',
            },
            { Header: intl.formatMessage({id: 'table.actions'}), 
              accessor: "Action", 
              width: "auto",
              minWidth: "4%",
              input: 'title',
              clearIcon: false,
            },
          ]}
          button={ [{
            add: null,
            detail: true,
            edit: false,
            delete: false,
            block: false,
          }] }
          icon={containerIcon}
          onOffset={ null }
          onLimit={ null }
          onAddItem={ null }
          onDetailItem={ handleDetailItem }
          onEditBtn={ null }
          onBlockItem={ null }
          onRemoveBtn={ null }
        />
      </Grid>

      { isOpenModal && (
        <EditTimeDoorWarning
        currentTime={warningTime}
          onCloseWindow={handleModalWindow}
        />
      )}
    </Grid>
  );
};

export default injectIntl(ContainersTable);